interface Props {
  code: string
  title: string
  icon: React.ReactNode
  isSelected: boolean
  onClick: (code: string) => void
  className?: string
  textClassName?: string
  isActiveButtonClassName?: string
}

export const ButtonLikeCheckbox = ({
  code,
  title,
  icon,
  isSelected,
  onClick,
  className,
  textClassName,
  isActiveButtonClassName
}: Props) => {
  return (
    <button
      type="button"
      key={code}
      className={`
        transition-all duration-150 border-[1px] px-4 py-[0.6875rem]
        flex items-center gap-1 h-[2.625rem] rounded-full
        hover:border-[#222]
        ${
          isSelected
            ? `border-[#222] bg-[#222] ${isActiveButtonClassName}`
            : 'border-[#EBEDF0] bg-white'
        } ${className}
        `}
      onClick={() => onClick(code)}
    >
        <p className={`text-[14px] font-normal ${isSelected ? 'text-white' : 'text-black'} ${textClassName}`}>
          {title}
        </p>
        <span className={`md:flex hidden ${isSelected ? 'text-white' : 'text-black'}`}>
          {icon}
        </span>
    </button>
  )
}

